var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostReplyNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,105h80c5.5,0 10,-4.5 10,-10v-62c0,-5.5 -4.5,-10 -10,-10h-80c-5.5,0 -10,4.5 -10,10v62c0,5.5 4.5,10 10,10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,108h-80c-7.2,0 -13,-5.8 -13,-13v-49c0,-1.7 1.3,-3 3,-3c1.7,0 3,1.3 3,3v49c0,3.9 3.1,7 7,7h80c3.9,0 7,-3.2 7,-6v-45c0,-1.7 1.3,-3 3,-3c1.7,0 3,1.3 3,3v45c0,6.4 -6.1,12 -13,12z",
    fill: "#2d3748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,69c-14.2,0 -27.4,-5.6 -37.2,-15.9c-1.1,-1.2 -1.1,-3.1 0.1,-4.2c1.2,-1.1 3.1,-1.1 4.2,0.1c8.7,9 20.3,14 32.8,14c12.5,0 24.2,-5 32.8,-14c1.1,-1.2 3,-1.2 4.2,-0.1c1.2,1.1 1.2,3 0.1,4.2c-9.6,10.3 -22.8,15.9 -37,15.9zM14,36c-1.7,0 -3,-1.3 -3,-3c0,-7.2 5.8,-13 13,-13h52c1.7,0 3,1.3 3,3c0,1.7 -1.3,3 -3,3h-52c-3.9,0 -7,3.1 -7,7c0,1.7 -1.3,3 -3,3z",
    fill: "#2d3748"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(14.78354,81.69175) rotate(-45.001)",
    d: "M106,3c-11.04569,0 -20,8.95431 -20,20c0,11.04569 8.95431,20 20,20c11.04569,0 20,-8.95431 20,-20c0,-11.04569 -8.95431,-20 -20,-20z",
    fill: "#29abe2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,34c-0.8,0 -1.5,-0.3 -2.1,-0.9l-8,-8c-0.9,-0.9 -1.1,-2.1 -0.7,-3.3c0.5,-1.1 1.6,-1.9 2.8,-1.9h19c1.7,0 3,1.3 3,3c0,1.7 -1.3,3 -3,3h-11.8l2.9,2.9c1.2,1.2 1.2,3.1 0,4.2c-0.6,0.7 -1.3,1 -2.1,1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,26c-0.8,0 -1.5,-0.3 -2.1,-0.9c-1.2,-1.2 -1.2,-3.1 0,-4.2l8,-8c1.2,-1.2 3.1,-1.2 4.2,0c1.2,1.2 1.2,3.1 0,4.2l-8,8c-0.6,0.6 -1.3,0.9 -2.1,0.9z",
    fill: "#ffffff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostReplyNotificationIcon);
export default __webpack_public_path__ + "static/media/post-reply-notification-icon.164b0a51ec92b0d96e2dbe9aa1121e30.svg";
export { ForwardRef as ReactComponent };